// flow weak

import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import styles                 from './style'
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import {Link} from 'react-router-dom';
import { withRouter } from 'react-router';
import DatePicker from 'react-datepicker';
import moment from 'moment';


class EditMatch extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      id: props.match.params.id,
      match: {
        "name": "",
        "venue": "",
        "game_type": 13,
        "start_time": "19:30:00",
        "end_time": "20:15:00",
        "match_date": moment(),
        },
      data_uploaded: false,
      data_error: false,
      venues: [],
      game_type: []
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleStartDate = this.handleStartDate.bind(this);
  }

  handleStartDate(date){
    var new_selected_one =  Object.assign({}, this.state.match);
    new_selected_one['match_date'] = date
    this.setState({match: new_selected_one});
  }

  componentDidMount() {
    this.getMatchList();
  }

  getMatchList() {
     const url = `${getLocationOrigin()}/eagleeye/${this.state.id}/get_details_for_edit_match/`;
     const options = {...defaultOptions};

     fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({ venues: data.venues, game_type: data.game_type, match: data.match }))
       .catch(error => error);
  }

  postEditedMatch(data, props) {
    const url = `${getLocationOrigin()}/eagleeye/edit_match/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({'match': data});
    console.log('Going to fetch');
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then(function(response){                      // first then()
          alert(response.message);
          props.history.goBack();
      })
      .catch(error => {
        console.log(error);
        alert(error.message);
      });
  }

  dayOfWeek() {
    return [
      {id:0, name: 'Monday'},
      {id:1, name: 'Tuesday'},
      {id:2, name: 'Wednesday'},
      {id:3, name: 'Thursday'},
      {id:4, name: 'Friday'},
      {id:5, name: 'Saturday'},
      {id:6, name: 'Sunday'},
    ]
  }

  handleChange(event) {
    const name = event.target.name;
    var new_selected_one = Object.assign({}, this.state.match);
    new_selected_one[name] = event.target.value
    this.setState({match: new_selected_one});
  }

  handleSubmit(event) {
    event.preventDefault();
    this.postEditedMatch(this.state.match, this.props);
  }

  render() {
    return(
      <div style={styles.container}>
        <div className="row col-md-8 table-bordered" style={styles.table}>
          <div style={styles.main_header} className="col-md-12">
            <h3 style={{textAlign:'center'}}>Edit Match</h3>
          </div>
          <form  className="validated-form form-horizontal" onSubmit={this.handleSubmit}>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Batch Name
              </div>
              <input type="text"
                style={styles.input}
                name="name"
                value={this.state.match.name}
                onChange={this.handleChange}/>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Venue
              </div>
              <select name="venue" className="col-md-6" style={styles.item_body} value={this.state.match.venue}
                onChange={this.handleChange}>
                {
                  this.state.venues.map((x, index) => (
                  <option key={x.id} value={x.id}>{x.name}</option>
                  ))
                }
              </select>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Match Date
              </div>
              <DatePicker selected={moment(this.state.match.match_date)} onChange={this.handleStartDate}/>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Game type
              </div>
              <select name="game_type" style={styles.item_body} className="col-md-6"
                value={this.state.match.game_type} onChange={this.handleChange}>
                {
                  this.state.game_type.map((x, index) => (
                  <option key={x.pk} value={x.pk}>{x.game + ' ' + x.name}</option>
                  ))
                }
              </select>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Start Time
              </div>
              <input type="text" style={styles.input} className="required" name="start_time" value={this.state.match.start_time}
                onChange={this.handleChange} placeholder="19:30:00"/>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                End Time
              </div>
              <input type="text" style={styles.input} name="end_time" className="required" value={this.state.match.end_time}
                onChange={this.handleChange} placeholder="20:30:00"/>
            </div>

            <div style={styles.button_submit} className="col-md-12">
              <input className="btn btn-lg" type="submit" value="Submit" style={{backgroundColor:'#302C35',
                color:'#ffffff'}}/>
            </div>
            <div className="col-md-12">
              {this.state.data_uploaded?<div className="text-success" style={styles.success}>* Fixture created successfully.</div>:''}
              {this.state.data_error?<div className="text-danger" style={styles.success}>* Error, creation failed.</div>:''}
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default EditMatch;



// WEBPACK FOOTER //
// ./src/app/views/partner/crud/editMatch/index.js